import UserBio from './UserBio';
export const components = {
  UserBio
};
flarum.reg.add('fof-user-bio', 'forum/components', null);